/**
 * Chunk Text Viewer (Fallback)
 *
 * Displays the cited chunk text directly when no full document preview
 * is available. Used as a fallback for formats without HTML preview.
 */

import { Download, FileText } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ChunkTextViewerProps {
  documentName: string
  chunkText: string
  sectionHeader: string | null
  onDownload: () => void
}

export function ChunkTextViewer({
  documentName,
  chunkText,
  sectionHeader,
  onDownload,
}: ChunkTextViewerProps) {
  return (
    <div className="flex flex-col items-center justify-start h-full w-full max-w-2xl mx-auto py-8 px-4 gap-6">
      <div className="flex items-center gap-2 text-muted-foreground">
        <FileText className="h-5 w-5" />
        <span className="text-sm font-medium">{documentName}</span>
      </div>

      {sectionHeader && (
        <div className="text-meta font-medium uppercase tracking-wide">
          {sectionHeader}
        </div>
      )}

      <div className="w-full rounded-lg border bg-amber-50/40 p-4">
        <p className="text-sm leading-relaxed whitespace-pre-wrap">{chunkText}</p>
      </div>

      <p className="text-meta text-center">
        Full document preview is not available for this file type.
      </p>

      <Button variant="ghost" onClick={onDownload}>
        <Download className="h-4 w-4 mr-2" />
        Download full document
      </Button>
    </div>
  )
}
